'use client';

import { AppBar } from '@/primitives';
import Navigation from './Navigation';
import { NAV_HEIGHT } from '@/configs/layout';

export default function DesktopToolbar() {
  return (
    <AppBar
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        border: 'none',
        borderBottom: '1px solid',
        borderBottomColor: 'divider',
        height: NAV_HEIGHT,
        backgroundColor: 'background.paper',
        boxShadow: 'none',
        zIndex: 1300,

        '@media print': {
          display: 'none',
        },
      }}
    >
      <Navigation />
    </AppBar>
  );
}
